/**
 * Central definition of all analytics events
 * This file serves as the single source of truth for event names
 * Matches iOS AnalyticsEvents.swift exactly
 */

/**
 * Analytics event names following v2 schema
 * All events use snake_case naming convention
 */
export enum AnalyticsEvent {
  // MARK: - User Lifecycle Events
  LOGIN_STARTED = 'auth_login_start',
  LOGIN_SUCCESS = 'auth_login_success',
  LOGIN_FAIL = 'auth_login_fail',
  VERIFY_OTP_START = 'verify_otp_start',
  LOGIN_METHOD_SELECTED = 'login_method_selected',
  USER_LOGGED_OUT = 'auth_logout_success',

  // MARK: - Store Selection
  STORE_SELECTED = 'store_selected',
  STORE_LIST_LOADED = 'store_list_loaded',

  // MARK: - Site Events
  SITE_SELECTED = 'site_selected',
  SITE_SEARCH_PERFORMED = 'site_search_performed',
  SITE_SORT_APPLIED = 'site_sort_applied',
  SITE_FILTER_APPLIED = 'site_filter_applied',

  // MARK: - Challan Events
  CHALLAN_DELETED = 'challan_deleted',
  CHALLAN_EDITED = 'challan_edited',
  ENTRY_DELETED = 'entry_deleted',
  ENTRY_EDITED = 'entry_edited',
  SEGMENT_CONTROL_CHANGED = 'segment_control_changed',

  // MARK: - Screen Views
  SCREEN_VIEW = 'screen_view', // Firebase automatic

  // MARK: - User Actions
  ACTION_BUTTON_CLICK = 'action_button_click',
  LANGUAGE_SELECTED = 'language_selected',
  ACTION_ITEM_SELECT = 'action_item_select',

  LIST_LOADED = 'list_loaded',

  // MARK: - Error Events
  ERROR_API_EXCEPTION = 'error_api_exception',
  ERROR_API_FAILURE = 'error_api_failure',
  ERROR_FORM_VALIDATION = 'error_form_validation',

  VIEW_DOCUMENT = 'view_document',
  FETCH_DOC_LINK = 'fetch_pdf_link',
}
